import { ConfigProps } from '../../config/config.props'
import { css, createGlobalStyle } from 'styled-components'

export const typography = (config: ConfigProps) => css`
  /* APPLICABLE TO ALL SIZES */
  * {
    &[data-variant='secondary'] {
      color: ${config.palette.secondary};
    }
    &[data-variant='hint'] {
      color: ${config.palette.hint};
    }
    &[data-variant='disabled'] {
      color: ${config.palette.disabled};
      cursor: not-allowed;
    }
  }

  button,
  [data-btn] {
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1.5;
    cursor: pointer;
    position: relative;
    border: 0.1rem solid transparent;
    min-height: 4.4rem;
    text-align: center;

    padding: ${config.spacingBaseUnit * 0.8}rem
      ${config.spacingBaseUnit * 2.8}rem;

    border-radius: ${config.elementsBorderRadius}rem;
    &[data-variant='primary'] {
      background: ${config.palette.primary};
      color: ${config.palette.secondary};

      &[data-bordered] {
        border: 0.1rem solid ${config.palette.primary};
        background: transparent;
        color: ${config.palette.primary};
      }
    }
    &[data-variant='secondary'] {
      background: ${config.palette.secondary};
      color: ${config.palette.primary};
    }

    &[data-variant='disabled'] {
      background: ${config.palette.disabled};
      color: ${config.palette.primary};
      opacity: 0.7;
    }

    &[data-variant='grey'] {
      background: ${config.palette.greyTitle};
      color: ${config.palette.secondary};
      opacity: 1;
    }

    &[data-variant='green'] {
      background: ${config.palette.silverTree};
      color: ${config.palette.secondary};
      min-height: 4rem;

      &[data-bordered] {
        border: 1px solid ${config.palette.silverTree};
        background: transparent;
        color: ${config.palette.silverTree};
      }
    }

    &[data-variant='add-to-basket'] {
      background: ${config.palette.salmon};
      color: ${config.palette.secondary};
      font-weight: 600;
      min-height: 4.4rem;

      &:hover {
        background: ${config.palette.silverTree} !important;
        opacity: 1 !important;
      }
    }

    &[data-variant='light'] {
      background: ${config.palette.hint};
      color: ${config.palette.primary};
      min-height: 4.4rem;

      &[data-bordered] {
        border: 1px solid ${config.palette.hint};
        background: transparent;
        color: ${config.palette.primary};

        &:hover {
          background: ${config.palette.panache};
        }
      }
    }

    &[data-variant='lightgrey'] {
      background: ${config.palette.disabled};
      color: ${config.palette.primary};
      min-height: 4.4rem;

      &[data-bordered] {
        border: 1px solid ${config.palette.disabled};
        background: transparent;
        color: ${config.palette.primary};

        &:hover {
          background: ${config.palette.panache};
        }
      }
    }

    &[disabled] {
      cursor: auto;
      pointer-events: none;
      * {
        opacity: 0.5;
      }
    }

    &[data-small] {
      min-height: 3.2rem;
      padding: 0.6rem 1.5rem;
      font-size: 1.2rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &[data-fullwidth] {
      width: 100%;
      display: block;
    }

    &:hover {
      opacity: 0.8;
    }

    &:focus {
      outline: 0 !important;
    }
  }

  [data-border-radius='small'] {
    border-radius: 0.4rem;
  }

  [data-border-radius='normal'] {
    border-radius: ${config.elementsBorderRadius}rem;
  }

  [data-border-radius='large'] {
    border-radius: ${config.elementsBorderRadius * 1.5}rem;
  }

  [data-border-radius='circle'] {
    border-radius: 50%;
  }

  [data-border-radius='none'] {
    border-radius: none;
  }

  /* BASE STYLES FOR MOBILE AND UP */
  body,
  [data-variant='base'] {
    color: ${config.palette.primary};
    font-size: 1.4rem;
  }

  h1,
  [data-variant='1'] {
    font-size: 3.2rem;
  }

  h2,
  [data-variant='2'] {
    font-size: 2.8rem;
  }

  h3,
  [data-variant='3'] {
    font-size: 2.4rem;
  }

  h4,
  [data-variant='4'] {
    font-size: 2rem;
  }

  h5,
  [data-variant='5'] {
    font-size: 1.8rem;
  }

  h6,
  [data-variant='6'] {
    font-size: 1.6rem;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  @media (min-width: ${config.breakpoints.sm.min}) {
    /* BASE STYLES FOR SMALL AND UP - EXTEND ONLY IF YOU NEED TO */
  }
  @media (min-width: ${config.breakpoints.md.min}) {
    /* BASE STYLES FOR MEDIUM AND UP - EXTEND ONLY IF YOU NEED TO */
  }
  @media (min-width: ${config.breakpoints.lg.min}) {
    /* BASE STYLES FOR LARGE AND UP - EXTEND ONLY IF YOU NEED TO */
  }
  @media (min-width: ${config.breakpoints.xl.min}) {
    /* BASE STYLES FOR X-LARGE AND UP - EXTEND ONLY IF YOU NEED TO */
  }
  @media (min-width: ${config.breakpoints.xxl.min}) {
    /* BASE STYLES FOR XX-LARGE AND UP - EXTEND ONLY IF YOU NEED TO */
  }
`

export const Typography = createGlobalStyle`${typography}`

export default typography
